import {
  ApiSlugs,
  ListPagination,
  StripeSubscriptionEventDto,
  StripeSubscriptionEventId,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class StripeSubscriptionEventsAdminConnector extends ApiConnector<
  StripeSubscriptionEventDto,
  StripeSubscriptionEventDto,
  StripeSubscriptionEventId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.STRIPE_SUBSCRIPTION_EVENTS);
  }

  summarized = () => ({
    list: (pagination?: ListPagination): Observable<StripeSubscriptionEventDto[]> =>
      this.apiCaller.getRequest<StripeSubscriptionEventDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
